// Shared by the Dashboard ("Upcoming Events") and Attendance ("Holidays")
// features — both read the same student/event endpoint and simply split its
// results by the is_holiday flag, so the parsing/sorting logic lives here
// once instead of being duplicated in each feature's hook.

// Confirmed against the real backend (2026-10-26): event_date is either a
// single date ("2027-03-26") or a range string ("2026-12-31 to 2027-01-08")
// — take the start of the range for sorting purposes.
export const parseEventStartDate = (event) => {
  const raw = event?.event_date;
  if (!raw) return null;
  const start = String(raw).split(" to ")[0].trim();
  const parsed = new Date(start);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

// Confirmed against the real backend (2026-10-26): is_holiday is "1"/"0"
// (string), not a boolean.
export const isHolidayEvent = (event) => String(event?.is_holiday) === "1";

const sortByDateAsc = (a, b) => a.date - b.date;

// Non-holiday events, from today onward, soonest first.
export const selectUpcomingEvents = (events) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events
    .filter((event) => !isHolidayEvent(event))
    .map((event) => ({ event, date: parseEventStartDate(event) }))
    .filter(({ date }) => date && date >= today)
    .sort(sortByDateAsc)
    .map(({ event }) => event);
};

// Holiday events, chronological.
export const selectHolidayEvents = (events) =>
  events
    .filter(isHolidayEvent)
    .map((event) => ({ event, date: parseEventStartDate(event) }))
    .sort(sortByDateAsc)
    .map(({ event }) => event);
